export default __webpack_public_path__ + "assets/eeceb5f471d2266cd90d2795c51315c4.jpeg";